<app-nav-bar></app-nav-bar>
<div class="d-flex flex-row w-100">
    <div [ngClass]="{'w-50 mr-1': showDelivery, 'w-100': !showDelivery}" class="border shadow-sm">
        <app-up-board-editor></app-up-board-editor>
    </div>
    <div *ngIf="showDelivery" class="w-50 ml-1 border shadow-sm">
        <app-manage-deliveries></app-manage-deliveries>
    </div>
</div>